/* eslint-disable no-lone-blocks */
import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import {
  DepositeSection,
  EnrollmentStepWrapper,
  PaymentusLabel,
  PaymentusOpenContent,
  PaymentusService,
  PaymentusText,
} from "../../styles/Enrollment.styled";
import {
  confirmEnrollment,
  confirmEnrollmentAfterDeposit,
  getEnrollmentRecord,
} from "../../../fetch/enrollment";
import { Button } from "../../styles/Button.styled";
import { fetchToken, paydeposite, paymentusToken } from "../../../fetch/fetch";
import { LoadingRow } from "../../LoadingRow";
import { useLocation, useNavigate } from "react-router-dom";
import { EnrollmentContext } from "./enrollment";
import { PAYMENT_IFRAME_URL, CONSTELLATION_UTIL_MAPPING, REFERER_URL } from "../../../config";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { Utilities, UtilityTypes } from "../../../types";
import { PhoneNumbers, pushEnrollmentOrderComplete, pushEnrollmentEventToDataLayer } from "../../data";

interface Props {
  show: boolean;
  enrollmentId: string;
  handleContinue: Function;
  handleBack: Function;
  enrollmentResult: any;
  sign: string;
  specialPro: {
    ssn: string;
    date_of_birth: string;
  };
  handleSSN: Function;
  handleSetName: Function;
  handleSetEmail: Function;
  utility: Utilities | undefined;
}

interface EnrollmentFields {
  email: string;
  phone?: string;
  first_name: string;
  last_name: string;
  service_address: string;
  service_city: string;
  service_state: string;
  service_zipcode: string;
  requested_date: string;
}

const getDepositConversionData = (data?: EnrollmentFields) => ({
  email: data?.email,
  phone: data?.phone,
});

export const PaymentStepReview: React.FC<Props> = ({
  show,
  enrollmentId,
  handleContinue,
  handleBack,
  enrollmentResult,
  sign,
  specialPro,
  handleSSN,
  handleSetName,
  handleSetEmail,
  utility,
}) => {
  const { t } = useTranslation("enrollment");
  const [loading, setLoading] = useState(true);
  const [iframeLoading, setIframeLoading] = useState(true);
  const [token, setToken] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [reviewData, setReviewData] = useState<EnrollmentFields | undefined>(
    undefined
  );
  const {  handleSetErrorModalContent, promoCode, serviceAddress, selectedProduct } =
    useContext<any>(EnrollmentContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [amount, setAmount] = useState();
  const [storageResult, setStorageResult] = useState();
  const [showText, setShowText] = useState(true);
  const [showError, setShowError] = useState(false);

  // console.log('enrollmentResult', enrollmentResult?.total?.response_vail.CustomerResponse.CustomerID)

  // console.log('CustomerId',customerId)

  useEffect(() => {
    if (!enrollmentResult) {
      const _enrollmentResult = localStorage.getItem("enrollmentResult");
      if (_enrollmentResult) {
        setStorageResult(JSON.parse(_enrollmentResult));
        setAmount(JSON.parse(_enrollmentResult).additional[0].deposit_amount);
        setCustomerId(JSON.parse(_enrollmentResult).additional[0].customer_id);
      }
    }
  }, []);
  useEffect(() => {
    if (enrollmentResult && show) {
      setAmount(enrollmentResult.additional[0].deposit_amount);
      setCustomerId(enrollmentResult.additional[0].customer_id);
    }

    if (enrollmentId && show) {
      getEnrollmentRecord(enrollmentId, sign).then((res: any) => {
        if (res && parseInt(res.status) === 1) {
          setReviewData(res.response);
          setLoading(false);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, enrollmentResult]);

  useEffect(() => {
    const _additional = localStorage.getItem("additional");
    if (_additional) {
      setAmount(JSON.parse(_additional).amount);
    }
  }, []);
  useEffect(() => {
    if (!show) return;
    window.digitalData.page.pageInfo.pageName = "Order Deposit";
  }, [show]);

  const handleSubmit = (
    reviewData: any,
    customerId: any,
    paymentToken: string
  ) => {
    paydeposite(
      reviewData.email,
      sign,
      customerId,
      paymentToken,
      enrollmentId
    ).then(async (res: any) => {
      if (res) {
        const { status } = res || {};
        if (status === "10.E01" || status === "40.E01") {
          if (status === "10.E01") {
            await pushEnrollmentOrderComplete(
              {
              event: "enrollment_order_complete",
              zip_code: utility?.zipcode,
              user_region: utility?.state_id ? utility.state_id : "TX",
              energy_type: "Electricity",

              provider:
                //@ts-ignore
                CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
                utility?.utility_code,
              electricity_plan_rate: selectedProduct.price1000,
              electricity_plan_term: selectedProduct.contract_term,
              Cancellation_fee: selectedProduct.cancel_fee,
              offer_code: localStorage.getItem("promoCode"),
              confirmation_number: customerId,
              esiid: serviceAddress[0].esiid,
              referrer_url: `${REFERER_URL}${location.search}`,
              Status: "Accepted"
            },
              getDepositConversionData(reviewData)
            );
            navigate(`/v2/enrollment/success${location.search}`);
            handleSetEmail(reviewData?.email || "");
          }
          if (status === "40.E01") {
            navigate(`/v2/enrollment/failed${location.search}`)
          }
          handleContinue(res);
        }
        if (status === "-1" || status === "20.E03") {
          await pushEnrollmentEventToDataLayer(
            {
            event: "enrollment_order_error",
            zip_code: serviceAddress[0].zipcode,
            user_region: serviceAddress[0].state,
            city: serviceAddress[0].city,
            provider:
              //@ts-ignore
              CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
              utility?.utility_code,
            electricity_plan_rate: selectedProduct.price1000,
            electricity_plan_term: selectedProduct.contract_term,
            electricity_plan_name: selectedProduct.plan_name,
            electricity_termination_fee: selectedProduct.cancel_fee,
            offer_code: localStorage.getItem("promoCode"),
            confirmation_number: customerId,
            esiid: serviceAddress[0].esiid,
            status: "Held/Rejected",
            error_message: res.message,
          },
            getDepositConversionData(reviewData)
          );
          handleSetErrorModalContent({
            title: res.message || t("Network Error"),
          });
          setShowError(true);
          return;
        }
      } else {
        handleSetErrorModalContent({
          title: res.message || t("Network Error"),
        });
        return;
      }
      if (res && res.status === '20.E02') {
        handleConfirm();
      }
      if (res && res.status === "20.E03") {
        navigate(`/v2/enrollment/failed${location.search}`)
        return handleContinue(res);
      }
    });
  };

  const handleConfirm = async () => {
    try {
      let shouldRetry = true;
      setIframeLoading(true)
      
      while (shouldRetry) {
        const res = await confirmEnrollmentAfterDeposit(enrollmentId, sign);
        
        if (!res) {
          navigate(`/v2/enrollment/failed${location.search}`);
          handleSetErrorModalContent({
            title: t("An error occurred"),
          });
          shouldRetry = false;
          return;
        }

        if (res.error_code) {
          if (res.error_code === "500") {
            handleSetErrorModalContent({
              title: res.message || t("The enrollment request has been submitted"),
            });
            shouldRetry = false;
            return;
          }
          navigate(`/v2/enrollment/failed${location.search}`);
          shouldRetry = false;
          return;
        }

        const { status } = res;
        if (status) {
          if (status === "20.E02") {
            await new Promise(resolve => setTimeout(resolve, 1000));
            continue; 
          }
          let errorCode:string = status.split(".")[0];
          shouldRetry = false; 
          // let  errorCode ="20"
          switch (errorCode ) {
            case "0":
            case "-1":
              navigate(`/v2/enrollment/failed${location.search}`);
              if (
                res.message &&
                (res.message.toLowerCase().indexOf("email_repeated") >= 0 ||
                  res.message.toLowerCase().indexOf("email_enrolled") >= 0)
              ) {
                handleSetErrorModalContent({
                  title: "Are you a current customer?",
                  desc: "It looks like you already have an account with us, please login to continue.",
                  button: "login",
                });
              } else {
                handleSetErrorModalContent({
                  title: t(res.message),
                });
              }
              if (res.message && res.message.indexOf("promoCode") >= 0) {
                handleBack();
                localStorage.setItem("promoCodeError", "1");
              }
              break;
            case "30":
              navigate(`/v2/enrollment/failed${location.search}`);
              if (
                res &&
                res.additional &&
                res.additional[0] &&
                res.additional[0].account_number === null
              ) {
                const depositAmount = res.additional[0].deposit_amount
                  ? res.additional[0].deposit_amount
                  : 0;
                handleSetErrorModalContent({
                  title: `A deposit is required to continue with this enrollment. Deposit amount: $${depositAmount}. Please give us a call at ${PhoneNumbers[promoCode]}. Our representatives are available to assist you Monday – Friday from 8:00am – 7:00pm CST.`,
                  desc: " ",
                  buttonTest: "Cancel",
                });
              } else {
                handleSSN(specialPro);
                handleContinue(res);
                handleSetName(
                  `${
                    reviewData
                      ? `${reviewData.first_name} ${reviewData.last_name}`
                      : ""
                  }`
                );
              }
              break;
            case "10":
              await pushEnrollmentOrderComplete(
                {
                event: "enrollment_order_complete",
                zip_code: utility?.zipcode,
                user_region: utility?.state_id ? utility.state_id : "TX",
                energy_type: "Electricity",
                provider:
                  //@ts-ignore
                  CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
                  utility?.utility_code,
                electricity_plan_rate: selectedProduct.price1000,
                electricity_plan_term: selectedProduct.contract_term,
                Cancellation_fee: selectedProduct.cancel_fee,
                offer_code: localStorage.getItem("promoCode"),
                confirmation_number: customerId,
                esiid: serviceAddress[0].esiid,
                referrer_url: `${REFERER_URL}${location.search}`,
                Status: "Accepted"
              },
                getDepositConversionData(reviewData)
              );
              navigate(`/v2/enrollment/success${location.search}`);
              handleSSN(specialPro);
              handleContinue(res);
              handleSetEmail(reviewData?.email || "");
              handleSetName(
                `${
                  reviewData
                    ? `${reviewData.first_name} ${reviewData.last_name}`
                    : ""
                }`
              );
              break;
              //TO-do check why case "20" missing here?
              case "20":
              localStorage.setItem('enrollmentResult', JSON.stringify(res));
                  navigate(`/enrollment/deposit${location.search}`)
              break;
            case "40":
            case "50":
              navigate(`/v2/enrollment/failed${location.search}`);
              handleSSN(specialPro);
              handleContinue(res);
              handleSetName(
                `${
                  reviewData
                    ? `${reviewData.first_name} ${reviewData.last_name}`
                    : ""
                }`
              );
              break;
            default:
              // Handle any other status codes if needed
              break;
          }
        } else {
          navigate(`/v2/enrollment/failed${location.search}`);
          handleSetErrorModalContent({
            title: t("An error occurred"),
          });
          shouldRetry = false;
        }
      }
    } catch (error) {
      handleSetErrorModalContent({
        title: t("An error occurred"),
      });
    }
  };

  const handleIframeLoad = () => {
    setIframeLoading(false);
  };

  const handleIframeError = () => {
    setIframeLoading(false);
    setShowText(false);
    setShowError(true);
  };

  function createData(name: string, content: any) {
    return { name, content };
  }

  const formatDate = (dateString: string | undefined) => {
    if (!dateString) {
      return;
    }
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };
  let rows = [
    createData("Your Constellation Customer ID", customerId),
    createData(
      "Your Service Address",
      `${reviewData?.service_address} ${reviewData?.service_city}, ${reviewData?.service_state} ${reviewData?.service_zipcode}`
    ),
    createData(
      "Your Requested Move Date",
      formatDate(reviewData?.requested_date)
    ),
    createData("Your Electricity Utility(TDSP)", utility?.utility_name),
    createData("Plan Name", selectedProduct.plan_name),
    createData("Rate (Based on 1,000 kWh)", `${selectedProduct.price1000}¢`),
    createData("Plan Length", `${selectedProduct.contract_term} Months`),
    createData("Promo Code", promoCode),
  ];

  useEffect(() => {
    if (!show) return;
    const handleMessage = async (event: any) => {
      try {
        if (typeof event.data === "string" && event.data.indexOf("ERROR") !== -1) {
          setIframeLoading(false);
          setShowError(true);
        }
        if (reviewData && event.data.Token) {
          setShowText(false);
          handleSubmit(reviewData, customerId, event.data.Token);
        }
      } catch (error) {
        console.error("Failed to get paymentusToken:", error);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reviewData, customerId]);

  // useEffect(() => {
  //   if (show && customerId) {
  //     pushToDataLayer({
  //       event: "enrollment_order_complete",
  //       zip_code: utility?.zipcode,
  //       user_region: utility?.state_id ? utility.state_id : "TX",
  //       energy_type: "Electricity",

  //       provider:
  //         //@ts-ignore
  //         CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
  //         utility?.utility_code,
  //       electricity_plan_rate: selectedProduct.price1000,
  //       electricity_plan_term: selectedProduct.contract_term,
  //       Cancellation_fee: selectedProduct.cancel_fee,
  //       offer_code: localStorage.getItem("promoCode"),
  //       confirmation_number: customerId,
  //       esiid:serviceAddress[0].esiid,
  //       referrer_url: `${REFERER_URL}${location.search}`,
  //       Status:"Deposit"
  //     });
  //   }
  // }, [show, customerId]);

  const pushData = () => {
    void pushEnrollmentEventToDataLayer(
      {
      event: "enrollment_order_complete",
      zip_code: utility?.zipcode,
      user_region: utility?.state_id ? utility.state_id : "TX",
      energy_type: "Electricity",
  
      provider:
      //@ts-ignore
      CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
      utility?.utility_code,
      electricity_plan_rate: selectedProduct.price1000,
      electricity_plan_term: selectedProduct.contract_term,
      Cancellation_fee: selectedProduct.cancel_fee,
      offer_code: localStorage.getItem("promoCode"),
      confirmation_number: customerId,
      esiid:serviceAddress[0].esiid,
      referrer_url: `${REFERER_URL}${location.search}`,
      Status:"Rejected"
    },
      getDepositConversionData(reviewData)
    );
  }
 


  useEffect(() => {
    if (reviewData) {
      fetchToken(
        reviewData.first_name,
        reviewData.last_name,
        reviewData.email
      ).then((res: any) => {
        setToken(res[0].token);
        setLoading(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reviewData]);

  const getContent = () => {
    if (loading || !token)
      return (
        <div className="pt-5 pb-5">
          <LoadingRow />
        </div>
      );
    return (
      <DepositeSection>
        <h4
          style={{
            fontSize: "1.5rem",
            color: "#2372b9",
            borderBottom: "2px solid #2372b9",
            padding: "10px 0",
            marginBottom: "10px",
          }}
        >
          You must pay a deposit in order to start service with Constellation
        </h4>
        {(showText || showError) && (
          <PaymentusOpenContent>
            {showText && !showError && (
              <PaymentusLabel>
                Based on the information provided, a deposit in the amount of $
                {amount} is required. You can request a Deposit Waiver from
                Constellation based on a letter of credit, proof that you are a
                senior citizen, or proof that you are a victim of family
                violence. Your service will not be switched or started with
                Constellation if you do not pay a deposit or provide and meet
                the Deposit Waiver requirements.
              </PaymentusLabel>
            )}
            {showError && (
              <PaymentusLabel>
                Based on the information provided, a deposit in the amount of $
                {amount} is required. Please reach out to our customer service
                team at {PhoneNumbers[promoCode]} to complete your enrollment.
                Constellation can often provide a Deposit Waiver based on a
                letter of credit, proof that you are a senior citizen, or proof
                that you are a victim of family violence. Your service will not
                be switched or started with Constellation if you do not pay a
                deposit or provide and meet the Deposit Waiver requirements.
              </PaymentusLabel>
            )}
            <PaymentusService>
              <h4 style={{ color: "#2372b9" }}>
                Constellation Customer Service:
              </h4>
              <a href={`tel:${PhoneNumbers[promoCode]}`}>
                {PhoneNumbers[promoCode]}
              </a>
              <p>Your Customer ID: {customerId}</p>
              <p>Your Promo Code : {promoCode}</p>
            </PaymentusService>
          </PaymentusOpenContent>
        )}
        {iframeLoading && <LoadingRow />}
        {!showError && (
          <iframe
            src={`${PAYMENT_IFRAME_URL}${token}`}
            height="500"
            width="100%"
            title="Iframe Example"
            onLoad={handleIframeLoad}
            onError={handleIframeError}
            className={iframeLoading ? "Loading-Iframe" : "Payment-Iframe"}
          />
        )}
        {/* <Button secondary onClick={() => handleBack()} disabled={loading}>
          {t("Back")}
        </Button> */}

        <TableContainer component={Paper}>
          <p
            style={{
              textAlign: "center",
              background: "#33669f",
              margin: "0",
              padding: "10px 0",
              color: "#fff",
              fontWeight: 500,
              fontSize: "20px",
            }}
          >
            Your Electricity Order Details
          </p>
          <Table aria-label="simple table">
            <TableBody>
              {rows.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    align="center"
                    style={{
                      background: "#cde4f9",
                      fontWeight: 600,
                      color: "#33669f",
                    }}
                  >
                    {row.name}
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{ background: "#f0f8fd", color: "#33669f" }}
                  >
                    {row.content}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DepositeSection>
    );
  };

  if (!show) return null;
  return <EnrollmentStepWrapper>{getContent()}</EnrollmentStepWrapper>;
};
